import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { DataTable } from '@/shared/ui/data-table';
import { RejectServiceRequestModal } from '@/features/reject-service-request-modal';

import { useServiceRequests } from '../lib';
import { getColumns } from '../model';

export function ServiceRequestsPage() {
  const { t } = useTranslation();
  const {
    tableData,
    summaryData,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    error,
    sortField,
    sortDirection,
    handleSort,
    actions,
    rejectTarget,
    closeRejectModal
  } = useServiceRequests();

  const columns = useMemo(() => getColumns(t), [t]);

  if (error) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          {t('serviceRequests.error.loadFailed', 'Failed to load service requests. Please try again later.')}
        </AlertDescription>
      </Alert>
    );
  }

  const title = summaryData?.pendingApproval
    ? t('serviceRequests.titleWithPending', 'Service Requests ({{count}} pending)', {
        count: summaryData.pendingApproval
      })
    : t('cmrlist.service.request.title', 'Service Requests');

  return (
    <div className="space-y-6">
      <DataTable
        data={tableData}
        columns={columns}
        title={title}
        tableId="service-requests-table"
        actions={actions}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        hasMore={hasNextPage || false}
        onLoadMore={fetchNextPage}
        sortField={sortField}
        sortDirection={sortDirection}
        onSort={handleSort}
        enableFullscreen
        enableColumnCustomization
        enableExport
      />

      <RejectServiceRequestModal
        isOpen={!!rejectTarget}
        onClose={closeRejectModal}
        serviceRequestId={rejectTarget ? Number(rejectTarget.id) : 0}
        trackIdnf={rejectTarget?.trackIdnf}
      />
    </div>
  );
}
